module.exports = __webpack_public_path__ + "assets/white-gov-logo-d16321.svg";